import api from "@/api/axiosInstance";
import type { ProductInstance } from "./productAPI";

interface CompublishMisc {
    has_improvement_system: boolean;
    has_risk_management: boolean;
    proof_of_reading: boolean;
    checklist: boolean;
    task: boolean;
    state_customer: boolean;
    spekter_customer: boolean;
    sso: boolean;
    compendia_porten: boolean;
    scim_active: boolean;
    chatbots_count: number;
    valid_domains: boolean;
}

interface Customer {
    id: number;
    name: string;
    createdAt: Date;
    createdBy: number;
    deletedAt: Date | null;
    favorite: boolean;
    updatedAt: Date;
    updatedBy: number;
    userCount: number;
    productCount: number;
    link: string;
    url: string | null;
    analyticsKey: string | null;
    superOfficeId: number;
    dynamicsId: number;
    customerProduct: ProductInstance[];
    compublishMisc: CompublishMisc | null;
    GA4PropertyId: number | null;
    adviserId: number;
    internalCustomer: boolean;
    externalCrawler: boolean;
}

interface ApiResponse<T> {
    data: T;
    Customer: Customer;
}

// Customer API calls
const getCustomers = async (): Promise<Customer[]> => {
    const response = (await api.get("admin/customers")).data as ApiResponse<Customer[]>;
    const data = response.data.map((customer) => {
        customer.createdAt = new Date(customer.createdAt);
        customer.updatedAt = new Date(customer.updatedAt);
        return customer;
    });
    return data;
};

export { getCustomers };

export type { Customer };
